// Shared income-breakdown body for the dashboard + budgets modals. Each
// occurrence row shows the planned amount and what actually landed for it
// (matchBreakdownActuals) — the landed/Δ annotation is what guides refining
// budgeted income against reality.
import { h } from '../core/dom';
import { formatCurrency } from '@lib/format';
import { formatDate, type IncomeBreakdownRow } from '@lib/budget';

export function breakdownBody(rows: IncomeBreakdownRow[]): HTMLElement {
	if (rows.length === 0) return h('p', { class: 'muted' }, 'No income scheduled yet.');
	const todayKey = formatDate(new Date());
	return h(
		'div',
		{},
		...rows.map((r) => {
			if (r.kind === 'marker') return h('div', { class: 'breakdown-row breakdown-marker' }, r.label);
			const annotation =
				r.actual != null
					? landedNote(r.actual, r.amount, r.combined)
					: r.date <= todayKey
						? h('span', { class: 'breakdown-actual missed' }, 'not landed')
						: h('span', { class: 'breakdown-actual muted' }, 'upcoming');
			return h(
				'div',
				{ class: 'breakdown-row' },
				h('span', {}, `${r.date} · ${r.label}`),
				h('span', { class: 'breakdown-amounts num' }, h('span', {}, formatCurrency(r.amount)), annotation)
			);
		})
	);
}

function landedNote(actual: number, expected: number, combined?: boolean): HTMLElement {
	const delta = actual - expected;
	const exact = Math.abs(delta) <= 0.005;
	const cls = exact || delta > 0 ? 'positive' : 'negative';
	const deltaTxt = exact ? '' : ` (${delta > 0 ? '+' : '−'}${formatCurrency(Math.abs(delta))})`;
	const note = h('span', { class: `breakdown-actual ${cls}` }, `landed ${formatCurrency(actual)}${deltaTxt}`);
	if (combined) {
		note.append(h('span', { class: 'muted', title: 'Shared with other line items in one bank deposit (or split across deposits)' }, ' · combined'));
	}
	return note;
}
